export const formatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\+1/g, "");
};

export const parsePhoneNumber = (phoneNumber: string) => {
  return phoneNumber.startsWith("+1") ? phoneNumber : `+1${phoneNumber}`;
};
